import React,{Component} from 'react';
import {variables} from './Variables.js';
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import parse from 'html-react-parser';
import axios from 'axios';

export class Cards extends Component{

    constructor(props){
        super(props);

        this.state={
            cards:[],
            cardData:[],
            Attribute:"",
            Card_Name:"",
            Card_NameFilter:"",
            AttributeFilter:"",
            PowerFilter:"",
            FocusFilter:"",
            RulesFilter:"",
            LevelFilter:"",
            SubtypeFilter:"",
            SupertypeFilter:"",
            cardsWOFIlter:[],
            cardsWFIlter:[],

            pageNumbers:[],
            currentPage:"1",
            setCurrentPage:"1",
            postsPerPage:"8",
            indexOfLastPost:"0",
            indexOfFirstPost:"0",

            PhotoPath:variables.PHOT_URL,
            APIPath:variables.API_URL
        }
    }

    FilterFn(){
        this.state.currentPage = 1
        this.state.indexOfLastPost = this.state.currentPage * this.state.postsPerPage
        this.state.indexOfFirstPost = this.state.indexOfLastPost - this.state.postsPerPage
        var Card_NameFilter=this.state.Card_NameFilter;
        var AttributeFilter = this.state.AttributeFilter;
        var PowerFilter = this.state.PowerFilter;
        var FocusFilter = this.state.FocusFilter;
        var RulesFilter = this.state.RulesFilter;
        var LevelFilter = this.state.LevelFilter;
        var SupertypeFilter = this.state.SupertypeFilter;
        var SubtypeFilter = this.state.SubtypeFilter;

        var filtData=this.state.cardsWOFIlter.filter(
            function(el){
                return el.Card_Name?.toString().toLowerCase().includes(
                    Card_NameFilter.toString().trim().toLowerCase()
                )&&
                el.Attribute?.toString().toLowerCase().includes(
                    AttributeFilter.toString().trim().toLowerCase()
                )&&
                el.Power?.toString().toLowerCase().includes(
                    PowerFilter.toString().trim().toLowerCase()
                )&&
                el.Focus?.toString().toLowerCase().includes(
                    FocusFilter.toString().trim().toLowerCase()
                )&&
                el.Rules?.toString().toLowerCase().includes(
                    RulesFilter.toString().trim().toLowerCase()
                )&&
                el.Attribute_Requirement?.toString().toLowerCase().includes(
                    LevelFilter.toString().trim().toLowerCase()
                )&&
                el.Supertype?.toString().toLowerCase().includes(
                    SupertypeFilter.toString().trim().toLowerCase()
                )&&
                el.Subtype?.toString().toLowerCase().includes(
                    SubtypeFilter.toString().trim().toLowerCase()
                )
            }
        );
        this.state.pageNumbers = []
        for (let i = 1; i <= Math.ceil(filtData.length / this.state.postsPerPage); i++) {
            this.state.pageNumbers.push(i);
        }
        this.setState({cards:filtData.slice(this.state.indexOfFirstPost,this.state.indexOfLastPost),cardsWFIlter:filtData});
        
    }

    sortResult(prop,asc){
        if(this.state.cardsWFIlter.length > 0){
            var sortData = this.state.cardsWFIlter
        }else{
            var sortData = this.state.cardsWOFIlter
        }

        var sortData=sortData.sort(function(a,b){
            if(asc){
                return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
            }
            else{
                return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
            }
        });

        this.setState({cards:sortData.slice(this.state.indexOfFirstPost,this.state.indexOfLastPost)});
    }

    resetResult(prop,asc){
        this.state.currentPage = 1
        this.state.indexOfLastPost = this.state.currentPage * this.state.postsPerPage
        this.state.indexOfFirstPost = this.state.indexOfLastPost - this.state.postsPerPage
        var sortData = this.state.cardsWOFIlter
        this.state.Card_NameFilter=""
        this.state.AttributeFilter=""
        this.state.PowerFilter=""
        this.state.FocusFilter=""
        this.state.RulesFilter=""
        this.state.LevelFilter=""
        this.state.SubtypeFilter=""
        this.state.SupertypeFilter=""
        this.state.pageNumbers=[]

        for (let i = 1; i <= Math.ceil(this.state.cardData.length / this.state.postsPerPage); i++) {
            this.state.pageNumbers.push(i);
        }

        var sortData=sortData.sort(function(a,b){
            if(asc){
                return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
            }
            else{
                return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
            }
        });

        this.setState({cards:sortData.slice(this.state.indexOfFirstPost,this.state.indexOfLastPost),cardsWFIlter:[]});
    }

    changeCard_NameFilter = (e)=>{
        this.state.currentPage=1
        this.state.Card_NameFilter=e.target.value;
        this.FilterFn();
    }
    changePowerFilter = (e)=>{
        this.state.currentPage=1
        this.state.PowerFilter=e.target.value;
        this.FilterFn();
    }  
    changeFocusFilter = (e)=>{
        this.state.currentPage=1
        this.state.FocusFilter=e.target.value;
        this.FilterFn();
    }    
    changeRulesFilter = (e)=>{
        this.state.currentPage=1
        this.state.RulesFilter=e.target.value;
        this.FilterFn();
    } 
    changeAttributeFilter = (e)=>{
        this.state.currentPage=1
        this.state.AttributeFilter=e.target.value;
        this.FilterFn();
    } 
    changeLevelFilter = (e)=>{
        this.state.currentPage=1
        this.state.LevelFilter=e.target.value;
        this.FilterFn();
    } 
    changeSubtypeFilter = (e)=>{
        this.state.currentPage=1
        this.state.SubtypeFilter=e.target.value;
        this.FilterFn();
    } 
    changeSupertypeFilter = (e)=>{
        this.state.currentPage=1
        this.state.SupertypeFilter=e.target.value;
        this.FilterFn();
    } 

    refreshList(){
        this.state.indexOfLastPost = this.state.currentPage * this.state.postsPerPage
        this.state.indexOfFirstPost = this.state.indexOfLastPost - this.state.postsPerPage
        this.state.Card_NameFilter=""
        this.state.AttributeFilter=""
        this.state.PowerFilter=""
        this.state.FocusFilter=""
        this.state.RulesFilter=""
        this.state.LevelFilter=""
        this.state.SubtypeFilter=""
        this.state.SupertypeFilter=""
        
        this.state.cardData.forEach(function(rule){
            //Fast
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>fast") & rule.Rules.toString().toLowerCase().includes("fast"))
            {rule.Rules = rule.Rules.toString().replace("Fast","<div class='tooltip2'>Fast <span class='tooltiptext2'>You may Plan this Action in both the Fast Action and Fast Reaction steps. You may Plan this Action as a Combo or a Replacement.</span></div>")}
            //Reach
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>reach") & rule.Rules.toString().toLowerCase().includes("reach"))
            {rule.Rules = rule.Rules.toString().replace("Reach","<div class='tooltip2'>Reach <span class='tooltiptext2'>If you began this moment engaged with your target, this action cannot miss due to distance.</span></div>")}
            //Ranged
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>ranged") & rule.Rules.toString().toLowerCase().includes("ranged"))
            {rule.Rules = rule.Rules.toString().replace("Ranged","<div class='tooltip2'>Ranged <span class='tooltiptext2'>This action cannot miss due to distance.</span></div>")}
            //Engage
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>engage") & rule.Rules.toString().toLowerCase().includes("engage"))
            {rule.Rules = rule.Rules.toString().replace("Engage","<div class='tooltip2'>Engage <span class='tooltiptext2'>Move toward your target and become engaged with them.</span></div>")}
            //Disengage
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>disengage") & rule.Rules.toString().toLowerCase().includes("disengage") &!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>engage"))
            {rule.Rules = rule.Rules.toString().replace("Disengage","<div class='tooltip2'>Disengage <span class='tooltiptext2'>Move away from your target and become disengaged from them.</span></div>")}
            //Move
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>move") & rule.Rules.toString().toLowerCase().includes("move") &!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>engage"))
            {rule.Rules = rule.Rules.toString().replace("Move","<div class='tooltip2'>Move <span class='tooltiptext2'>If you are currently engaged, disengage. If you are currently disengaged, engage.</span></div>")}
            //check
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>check") & rule.Rules.toString().toLowerCase().includes("check"))
            {rule.Rules = rule.Rules.toString().replace("check","<div class='tooltip2'>check <span class='tooltiptext2'>Roll 1d4+X, where X is the total attribute requirement of actions you've performed this turn. Your target does the same. The player with the highest total wins the check. You win on a tie.</span></div>")}
            //Improved
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>improved") & rule.Rules.toString().toLowerCase().includes("improved"))
            {rule.Rules = rule.Rules.toString().replace("Improved","<div class='tooltip2'>Improved <span class='tooltiptext2'>When making a roll for this action, make an additional roll and use the higher result. If an action has both Improved and Impaired, the two keywords cancel each other out.</span></div>")}
            //Impaired
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>impaired") & rule.Rules.toString().toLowerCase().includes("impaired") &!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>improved"))
            {rule.Rules = rule.Rules.toString().replace("Impaired","<div class='tooltip2'>Impaired <span class='tooltiptext2'>When making a roll for this action, make an additional roll and use the lower result. If an action has both Improved and Impaired, the two keywords cancel each other out.</span></div>")}
            //Spellfuse
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>spellfuse") & rule.Rules.toString().toLowerCase().includes("spellfuse"))
            {rule.Rules = rule.Rules.toString().replace("Spellfuse","<div class='tooltip2'>Spellfuse <span class='tooltiptext2'>You may create a Combo with this Action and any other Magical Action in your hand prior to Planning the Combined Action. Treat the Combined Action as a single card when it is Planned.</span></div>")}
            //Skillfuse
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>skillfuse") & rule.Rules.toString().toLowerCase().includes("skillfuse"))
            {rule.Rules = rule.Rules.toString().replace("Skillfuse","<div class='tooltip2'>Skillfuse <span class='tooltiptext2'>You may create a Combo with this Action and any other Physical Action in your hand prior to Planning the Combined Action. Treat the Combined Action as a single card when it is Planned.</span></div>")}
            //Blessed
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>blessed") & rule.Rules.toString().toLowerCase().includes("blessed") &!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>holy symbol"))
            {rule.Rules = rule.Rules.toString().replace("Blessed","<div class='tooltip2'>Blessed <span class='tooltiptext2'>Before you pay to perform this action, create a token that is a copy of your holy symbol’s action and combine it with this.</span></div>")}
            //Holy Symbol
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>holy symbol") & rule.Rules.toString().toLowerCase().includes("holy symbol") &!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>blessed"))
            {rule.Rules = rule.Rules.toString().replace("Holy Symbol","<div class='tooltip2'>Holy Symbol <span class='tooltiptext2'>Your build cannot contain more than one holy symbol. Actions with Blessed will gain a benefit from this card.</span></div>")}
            //Divine Enemy:
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>divine enemy") & rule.Rules.toString().toLowerCase().includes("divine enemy"))
            {rule.Rules = rule.Rules.toString().replace("Divine Enemy","<div class='tooltip2'>Divine Enemy <span class='tooltiptext2'>Your build cannot contain [Type] actions. Ex: If your divine enemy is Fire, your build cannot contain cards with the Fire subtype.</span></div>")}
            //Amplify
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>amplify") & rule.Rules.toString().toLowerCase().includes("amplify"))
            {rule.Rules = rule.Rules.toString().replace("Amplify","<div class='tooltip2'>Amplify <span class='tooltiptext2'>When paying for this action, you may [pay additional] in addition to its cost. If you do, this action is considered amplified until end of turn.</span></div>")}
            //Dragonrage
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>dragonrage") & rule.Rules.toString().toLowerCase().includes("dragonrage"))
            {rule.Rules = rule.Rules.toString().replace("Dragonrage","<div class='tooltip2'>Dragonrage <span class='tooltiptext2'>When you plan this action, you may create an Inner Dragon token as a combo with this action. If you do, create a Vulnerable token in the following moment as a replacement.</span></div>")}
            //Momentum
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>momentum") & rule.Rules.toString().toLowerCase().includes("momentum"))
            {rule.Rules = rule.Rules.toString().replace("Momentum","<div class='tooltip2'>Momentum <span class='tooltiptext2'>As long as you moved in either this moment or the previous moment, this action will have a bonus effect.</span></div>")}
            //Armor
            if(!rule.Rules.toString().toLowerCase().includes("armor</div>") & rule.Rules.toString().toLowerCase().includes("armor"))
            {rule.Rules = rule.Rules.toString().replace("armor","<div class='tooltip2'>Armor <span class='tooltiptext2'>Prevent [X] damage from any unopposed Physical/Magical actions that damage you during the clash. Armors of the same type cannot overlap.Example: If you have Physical Armor: 2 and Physical Armor: 1, you must choose one to be in effect. You do not have Physical Armor: 3.</span></div>")}
        })
        var slicedCards = this.state.cardData.slice(this.state.indexOfFirstPost,this.state.indexOfLastPost)

        this.sortResult("sortID",true)

        this.setState({cards:slicedCards,cardsWOFIlter:this.state.cardData});
    }

    firstRefreshList(cData){
        cData = cData || null;
        if(cData != null)
        {
            this.setState({cardData:cData})
        }

        this.state.indexOfLastPost = this.state.currentPage * this.state.postsPerPage
        this.state.indexOfFirstPost = this.state.indexOfLastPost - this.state.postsPerPage
        this.state.Card_NameFilter=""
        this.state.AttributeFilter=""
        this.state.PowerFilter=""
        this.state.FocusFilter=""
        this.state.RulesFilter=""
        this.state.LevelFilter=""
        this.state.SubtypeFilter=""
        this.state.SupertypeFilter=""
        
        cData.forEach(function(rule){
            //Fast
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>fast") & rule.Rules.toString().toLowerCase().includes("fast"))
            {rule.Rules = rule.Rules.toString().replace("Fast","<div class='tooltip2'>Fast <span class='tooltiptext2'>You may Plan this Action in both the Fast Action and Fast Reaction steps. You may Plan this Action as a Combo or a Replacement.</span></div>")}
            //Reach
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>reach") & rule.Rules.toString().toLowerCase().includes("reach"))
            {rule.Rules = rule.Rules.toString().replace("Reach","<div class='tooltip2'>Reach <span class='tooltiptext2'>If you began this moment engaged with your target, this action cannot miss due to distance.</span></div>")}
            //Ranged
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>ranged") & rule.Rules.toString().toLowerCase().includes("ranged"))
            {rule.Rules = rule.Rules.toString().replace("Ranged","<div class='tooltip2'>Ranged <span class='tooltiptext2'>This action cannot miss due to distance.</span></div>")}
            //Engage
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>engage") & rule.Rules.toString().toLowerCase().includes("engage"))
            {rule.Rules = rule.Rules.toString().replace("Engage","<div class='tooltip2'>Engage <span class='tooltiptext2'>Move toward your target and become engaged with them.</span></div>")}
            //Disengage
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>disengage") & rule.Rules.toString().toLowerCase().includes("disengage") &!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>engage"))
            {rule.Rules = rule.Rules.toString().replace("Disengage","<div class='tooltip2'>Disengage <span class='tooltiptext2'>Move away from your target and become disengaged from them.</span></div>")}
            //Move
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>move") & rule.Rules.toString().toLowerCase().includes("move") &!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>engage"))
            {rule.Rules = rule.Rules.toString().replace("Move","<div class='tooltip2'>Move <span class='tooltiptext2'>If you are currently engaged, disengage. If you are currently disengaged, engage.</span></div>")}
            //check
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>check") & rule.Rules.toString().toLowerCase().includes("check"))
            {rule.Rules = rule.Rules.toString().replace("check","<div class='tooltip2'>check <span class='tooltiptext2'>Roll 1d4+X, where X is the total attribute requirement of actions you've performed this turn. Your target does the same. The player with the highest total wins the check. You win on a tie.</span></div>")}
            //Improved
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>improved") & rule.Rules.toString().toLowerCase().includes("improved"))
            {rule.Rules = rule.Rules.toString().replace("Improved","<div class='tooltip2'>Improved <span class='tooltiptext2'>When making a roll for this action, make an additional roll and use the higher result. If an action has both Improved and Impaired, the two keywords cancel each other out.</span></div>")}
            //Impaired
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>impaired") & rule.Rules.toString().toLowerCase().includes("impaired") &!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>improved"))
            {rule.Rules = rule.Rules.toString().replace("Impaired","<div class='tooltip2'>Impaired <span class='tooltiptext2'>When making a roll for this action, make an additional roll and use the lower result. If an action has both Improved and Impaired, the two keywords cancel each other out.</span></div>")}
            //Spellfuse
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>spellfuse") & rule.Rules.toString().toLowerCase().includes("spellfuse"))
            {rule.Rules = rule.Rules.toString().replace("Spellfuse","<div class='tooltip2'>Spellfuse <span class='tooltiptext2'>You may create a Combo with this Action and any other Magical Action in your hand prior to Planning the Combined Action. Treat the Combined Action as a single card when it is Planned.</span></div>")}
            //Skillfuse
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>skillfuse") & rule.Rules.toString().toLowerCase().includes("skillfuse"))
            {rule.Rules = rule.Rules.toString().replace("Skillfuse","<div class='tooltip2'>Skillfuse <span class='tooltiptext2'>You may create a Combo with this Action and any other Physical Action in your hand prior to Planning the Combined Action. Treat the Combined Action as a single card when it is Planned.</span></div>")}
            //Blessed
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>blessed") & rule.Rules.toString().toLowerCase().includes("blessed") &!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>holy symbol"))
            {rule.Rules = rule.Rules.toString().replace("Blessed","<div class='tooltip2'>Blessed <span class='tooltiptext2'>Before you pay to perform this action, create a token that is a copy of your holy symbol’s action and combine it with this.</span></div>")}
            //Holy Symbol
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>holy symbol") & rule.Rules.toString().toLowerCase().includes("holy symbol") &!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>blessed"))
            {rule.Rules = rule.Rules.toString().replace("Holy Symbol","<div class='tooltip2'>Holy Symbol <span class='tooltiptext2'>Your build cannot contain more than one holy symbol. Actions with Blessed will gain a benefit from this card.</span></div>")}
            //Divine Enemy:
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>divine enemy") & rule.Rules.toString().toLowerCase().includes("divine enemy"))
            {rule.Rules = rule.Rules.toString().replace("Divine Enemy","<div class='tooltip2'>Divine Enemy <span class='tooltiptext2'>Your build cannot contain [Type] actions. Ex: If your divine enemy is Fire, your build cannot contain cards with the Fire subtype.</span></div>")}
            //Amplify
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>amplify") & rule.Rules.toString().toLowerCase().includes("amplify"))
            {rule.Rules = rule.Rules.toString().replace("Amplify","<div class='tooltip2'>Amplify <span class='tooltiptext2'>When paying for this action, you may [pay additional] in addition to its cost. If you do, this action is considered amplified until end of turn.</span></div>")}
            //Dragonrage
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>dragonrage") & rule.Rules.toString().toLowerCase().includes("dragonrage"))
            {rule.Rules = rule.Rules.toString().replace("Dragonrage","<div class='tooltip2'>Dragonrage <span class='tooltiptext2'>When you plan this action, you may create an Inner Dragon token as a combo with this action. If you do, create a Vulnerable token in the following moment as a replacement.</span></div>")}
            //Momentum
            if(!rule.Rules.toString().toLowerCase().includes("<div class='tooltip2'>momentum") & rule.Rules.toString().toLowerCase().includes("momentum"))
            {rule.Rules = rule.Rules.toString().replace("Momentum","<div class='tooltip2'>Momentum <span class='tooltiptext2'>As long as you moved in either this moment or the previous moment, this action will have a bonus effect.</span></div>")}
            //Armor
            if(!rule.Rules.toString().toLowerCase().includes("armor</div>") & rule.Rules.toString().toLowerCase().includes("armor"))
            {rule.Rules = rule.Rules.toString().replace("armor","<div class='tooltip2'>Armor <span class='tooltiptext2'>Prevent [X] damage from any unopposed Physical/Magical actions that damage you during the clash. Armors of the same type cannot overlap.Example: If you have Physical Armor: 2 and Physical Armor: 1, you must choose one to be in effect. You do not have Physical Armor: 3.</span></div>")}
        })
        var slicedCards = cData.slice(this.state.indexOfFirstPost,this.state.indexOfLastPost)

        this.sortResult("sortID",true)

        this.setState({cards:slicedCards,cardsWOFIlter:cData});
    }

    paginate = (e)=>{
        var pNum = e.target.value
        this.state.currentPage = pNum

        if(this.state.cardsWFIlter.length > 0){
            this.state.indexOfLastPost = this.state.currentPage * this.state.postsPerPage
            this.state.indexOfFirstPost = this.state.indexOfLastPost - this.state.postsPerPage
            var slicedCards = this.state.cardsWFIlter.slice(this.state.indexOfFirstPost,this.state.indexOfLastPost)
            this.setState({cards:slicedCards});
        }else{
            this.refreshList();
        }
        
    }

    async componentDidMount(){
        if(this.state.cardData.length === 0){
            await axios.get(this.state.APIPath)
                .then(res => {
                    const cardD = res.data
                this.setState({cardData:cardD})
                this.setState({cards:cardD})
                for (let i = 1; i <= Math.ceil(cardD.length / this.state.postsPerPage); i++) {
                    this.state.pageNumbers.push(i)
                }
                this.firstRefreshList(cardD);
              })

        }else{
            for (let i = 1; i <= Math.ceil(this.state.cardData.length / this.state.postsPerPage); i++) {
                this.state.pageNumbers.push(i)
            }
            this.refreshList();
        }
        
    }

    showStacks(){
      var modal = document.getElementById("divStacks")
    
      modal.style.display = "block";
    }
    closeModal(){
        var modal6 = document.getElementById("divStacks")
        
        modal6.style.display = "none";
      }
    render(){
        const {
            cards
        }=this.state;


return(
<div className='container-fluid colorBG'>

    <button type="button"
    className="btn btn-outline-warning m-2 float-start"
    onClick={()=>this.resetResult('id',true)}
    value="1">
        Reset Results
    </button>
    <input className='btn btn-outline-warning m-2 float-start' type='button' value='Stacks' id='myBtn4'
    onClick={()=>this.showStacks()}
    />
    <table className="table table-dark table-striped">
    <thead>
    <tr>
        <th className='wide12per'>
            Name
            <div className="d-flex flex-row">
            <input className="form-control m-2"
            value={this.state.Card_NameFilter}
            onChange={this.changeCard_NameFilter}/>
        
            </div>
        </th>
        <th>
            Rules
            <div className="d-flex flex-row">
            <input className="form-control m-2"
            value={this.state.RulesFilter}
            onChange={this.changeRulesFilter}/>
            </div>
        </th>        
        <th>
            Power
            <div className="d-flex flex-row">
            <input className="form-control m-2"
            value={this.state.PowerFilter}
            onChange={this.changePowerFilter}/>

            <button type="button" className="btn btn-dark"
            onClick={()=>this.sortResult('Power',true)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down-square-fill" viewBox="0 0 16 16">
                <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"/>
                </svg>
            </button>

            <button type="button" className="btn btn-dark"
            onClick={()=>this.sortResult('Power',false)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up-square-fill" viewBox="0 0 16 16">
                <path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>
                </svg>
            </button>

            </div>
        </th>
        <th>Focus
            <div className="d-flex flex-row">
            <input className="form-control m-2"
            value={this.state.FocusFilter}
            onChange={this.changeFocusFilter}/>

            <button type="button" className="btn btn-dark"
            onClick={()=>this.sortResult('Focus',true)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down-square-fill" viewBox="0 0 16 16">
                <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"/>
                </svg>
            </button>

            <button type="button" className="btn btn-dark"
            onClick={()=>this.sortResult('Focus',false)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up-square-fill" viewBox="0 0 16 16">
                <path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>
                </svg>
            </button>

            </div>
        </th>
        <th>
            Supertype
            <div className="d-flex flex-row">
            <input className="form-control m-2"
            value={this.state.SupertypeFilter}
            onChange={this.changeSupertypeFilter}/>

            </div>
        </th>  
        <th>
            Subtype
            <div className="d-flex flex-row">
            <input className="form-control m-2"
            value={this.state.SubtypeFilter}
            onChange={this.changeSubtypeFilter}/>

            </div>
        </th>
        <th>
            Attribute/Item Type
            <div className="d-flex flex-row">
            <input className="form-control m-2"
            value={this.state.AttributeFilter}
            onChange={this.changeAttributeFilter}/>

            <button type="button" className="btn btn-dark"
            onClick={()=>this.sortResult('Attribute_Requirement',true)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down-square-fill" viewBox="0 0 16 16">
                <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"/>
                </svg>
            </button>

            <button type="button" className="btn btn-dark"
            onClick={()=>this.sortResult('Attribute_Requirement',false)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up-square-fill" viewBox="0 0 16 16">
                <path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>
                </svg>
            </button>
            </div>
      
        </th>  

        <th>
            Attribute Level/Gold Cost
            <div className="d-flex flex-row">
            <input className="form-control m-2"
            value={this.state.LevelFilter}
            onChange={this.changeLevelFilter}/>

            <button type="button" className="btn btn-dark"
            onClick={()=>this.sortResult('Attribute_Requirement',true)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down-square-fill" viewBox="0 0 16 16">
                <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"/>
                </svg>
            </button>

            <button type="button" className="btn btn-dark"
            onClick={()=>this.sortResult('Attribute_Requirement',false)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up-square-fill" viewBox="0 0 16 16">
                <path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>
                </svg>
            </button>
            </div>
        </th>
    </tr>
    </thead>
    <tbody>
        {cards.length===0 ? (<em>loading</em>) : (cards.map(dep=>
            <tr key={dep.Card_Name}>
                <td>{dep.Card_Name}<br/>
                <Zoom overlayBgColorEnd={'rgba(255, 255, 255, 0.15)'}>
                <img className="wide136px h190px" src={process.env.PUBLIC_URL+'./assets/images/'+dep.fileloc}/>
                </Zoom>
                </td>
                <td className='textLeft wsPreWrap'>{parse(dep.Rules)}</td>
                <td>{dep.Power}</td>
                <td>{dep.Focus}</td>
                <td>{dep.Supertype}</td>
                <td>{dep.Subtype}</td>
                <td>{dep.Attribute}</td>
                <td>{dep.Attribute_Requirement}</td>
            </tr>
            ))}
    </tbody>
    </table>
    <ul className='pagination'>
        {this.state.pageNumbers.map(number => (
          <li key={number} className='page-item'>
            <input type='button' onClick={this.paginate} className='page-link' value={number}>
            </input>
          </li>
        ))}
      </ul>    
      <div id="divStacks" className='modal'>
        <div className="modal-content wide80perImp">
          <span className="close" onClick={()=>this.closeModal()}>&times;</span>
          <div className='flex-container'>
            <Zoom overlayBgColorEnd={'rgba(255, 255, 255, 0.15)'}>
                <img className='wide211px h295px' src={'./assets/images/Stacks/Bleeding.jpg'}/>
            </Zoom>
            <Zoom overlayBgColorEnd={'rgba(255, 255, 255, 0.15)'}>
                <img className='wide211px h295px' src={'./assets/images/Stacks/Charmed.jpg'}/>
            </Zoom>
            <Zoom overlayBgColorEnd={'rgba(255, 255, 255, 0.15)'}>
                <img className='wide211px h295px' src={'./assets/images/Stacks/Chi.jpg'}/>
            </Zoom>
            <Zoom overlayBgColorEnd={'rgba(255, 255, 255, 0.15)'}>
                <img className='wide211px h295px' src={'./assets/images/Stacks/Confused.jpg'}/>
            </Zoom>
            <Zoom overlayBgColorEnd={'rgba(255, 255, 255, 0.15)'}>
                <img className='wide211px h295px' src={'./assets/images/Stacks/Dragonborne.jpg'}/>
            </Zoom>
            <Zoom overlayBgColorEnd={'rgba(255, 255, 255, 0.15)'}>
                <img className='wide211px h295px' src={'./assets/images/Stacks/Enraged.jpg'}/>
            </Zoom>
            <Zoom overlayBgColorEnd={'rgba(255, 255, 255, 0.15)'}>
                <img className='wide211px h295px' src={'./assets/images/Stacks/Eyes of the Goddess.jpg'}/>
            </Zoom>
            <Zoom overlayBgColorEnd={'rgba(255, 255, 255, 0.15)'}>
                <img className='wide211px h295px' src={'./assets/images/Stacks/Fatigue.jpg'}/>
            </Zoom>
            <Zoom overlayBgColorEnd={'rgba(255, 255, 255, 0.15)'}>
                <img className='wide211px h295px' src={'./assets/images/Stacks/Hemotoxin.jpg'}/>
            </Zoom>
            <Zoom overlayBgColorEnd={'rgba(255, 255, 255, 0.15)'}>
                <img className='wide211px h295px' src={'./assets/images/Stacks/Molten.jpg'}/>
            </Zoom>
            <Zoom overlayBgColorEnd={'rgba(255, 255, 255, 0.15)'}>
                <img className='wide211px h295px' src={'./assets/images/Stacks/Rooted.jpg'}/>
            </Zoom>
            <Zoom overlayBgColorEnd={'rgba(255, 255, 255, 0.15)'}>
                <img className='wide211px h295px' src={'./assets/images/Stacks/Unbeatable.jpg'}/>
            </Zoom>
        </div>
        </div>
      </div>
</div>
        )
    }
}